import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    flash: {
      active: false,
      type: '',  // success, error
      message: ''
    },

    flags: {
      quoteIsLoaded: false,
      quoteHasBeenEdited: false
    },

    quote: {
      id: 0,
      project_id: 0,
      version: 1,
      payload: {},
      meta: {}
    },

    options: {
      optionalRate: 115,
      newlineRate: 75,
      hostingBase: 10,
      hostingRatio: 0.75,
      supportBase: 20,
      supportRatio: 0.75
    },

    itemTypes: [
      { value: 'des', label: 'Design', abbr: 'Design' },
      { value: 'dev', label: 'Development', abbr: 'Dev' },
      { value: 'sdv', label: 'Standard Development', abbr: 'Std.Dev' },
      { value: 'oth', label: 'Other', abbr: 'Other' }
    ],

    authToken: '',

    quoteTemplates: []
  },

  mutations: {
    [types.SET_AUTH_TOKEN] (state, payload) {
      state.authToken = payload
    },

    [types.LOAD_QUOTE] (state, payload) {
      state.quote = payload.quote
      if (typeof state.quote.payload.fixed_cost_items === 'undefined') {
        console.log('Adding fixed_cost_items...')
        state.quote.payload.fixed_cost_items = { amount: 0, items: [] }
      }
      state.flags.quoteHasBeenEdited = false
    },

    [types.SET_QUOTE_LOADED] (state) {
      state.flags.quoteIsLoaded = true
    },

    [types.UPDATE_QUOTE] (state, payload) {
      state.quote.payload = JSON.parse(payload.payload)
      if (typeof state.quote.payload.fixed_cost_items === 'undefined') {
        state.quote.payload.fixed_cost_items = { amount: 0, items: [] }
      }
      state.flags.quoteHasBeenEdited = true
    },

    [types.SET_QUOTE_SAVED] (state) {
      state.flags.quoteHasBeenEdited = false
    },

    [types.UPDATE_QUOTE_PARAMS] (state, payload) {
      state.quote.payload.rate = payload.rate
      state.quote.payload.pm_ratio = payload.pmRatio
      state.quote.payload.show_hosting = payload.showHosting
      state.flags.quoteHasBeenEdited = true
    },

    [types.UPDATE_OPTIONAL_RATE] (state, payload) {
      state.options.optionalRate = payload
    },

    [types.SET_QUOTE_TEMPLATES] (state, payload) {
      state.quoteTemplates = payload.quoteTemplates
    },

    [types.SET_QUOTE_META] (state, payload) {
      state.quote.project_id = payload.project_id
      state.quote.meta = {
        job_no: payload.job_no,
        customer: payload.customer,
        title: payload.title
      }
    },

    [types.SET_FLASH] (state, payload) {
      state.flash.active = true
      state.flash.type = payload.type
      state.flash.message = payload.message
    },

    [types.CLEAR_FLASH] (state) {
      state.flash.active = false
    }
  },

  actions,
  getters,
  strict: true
})



// WEBPACK FOOTER //
// ./src/store/index.js